import * as React from 'react';

interface IProps {
  id: string;
  selected?: boolean;
  dropdownLabel: string;
  onOptionClick: (value: string, e: any) => void;
}

export function DropdownOption(props: IProps) {
  const { dropdownLabel, onOptionClick, selected } = props;
  return (
    <div
      className={'inputSelectOption' + (selected ? ' active' : '')}
      onMouseDown={(e) => e.preventDefault()}
      onMouseUp={(e) => onOptionClick(dropdownLabel, e)}
    >
      {dropdownLabel}
    </div>
  );
}
